Controller.$inject = [];

function Controller() {

}

export function HuiButton() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            sizing: '@',
            variant: '@',
            noPadding: '<',
            busy: '<',
            shape: '@',
            isFullWidth: '<',
        },
        controller: Controller,
        controllerAs: '$huiButtonCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            const tag = $attrs['uiSref'] || $attrs['href'] || $attrs['ngHref'] ? 'a' : 'button';

            return `
                <${tag} class="hui hui-button"
                        ng-class="[ 
                            'hui-' + ($huiButtonCtrl.color || 'accent'),
                            $huiButtonCtrl.sizing || 'md',
                            $huiButtonCtrl.variant || 'solid',
                            $huiButtonCtrl.shape || 'round',
                            { 'p-0': $huiButtonCtrl.noPadding,
                            'w-100': $huiButtonCtrl.isFullWidth,
                              'busy': $huiButtonCtrl.busy }
                        ]">
                         <i ng-if="$huiButtonCtrl.busy" class="fa fa-circle-notch fa-spin"></i>
                         <ng-transclude class="d-flex align-items-center gap-1"></ng-transclude>
                </${tag}>
            `;
        }
    }
}